import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import VSpace from "../../common/VSpace"
import { Segmented, Skeleton } from "antd"
import { SetStateAction, useState } from "react"
import { faList, faTable } from "@fortawesome/pro-solid-svg-icons"
import { useInvoiceDetailsQuery } from "../../../domain/invoicing/invoicingQueries"
import { InvoiceSummary } from "../../../domain/invoicing/invoice"
import LineItemsTable from "./LineItemsTable"
import InvoiceControls from "./InvoiceControls"
import { hasValue } from "../../../helpers/nullable"
import { SegmentedOptions } from "antd/es/segmented"

type Props = {
  invoiceSummary: InvoiceSummary
  preventExports: boolean
}

const InvoiceDetails = ({ invoiceSummary, preventExports }: Props) => {
  const detailsQuery = useInvoiceDetailsQuery(invoiceSummary.invoiceId)
  const [tableView, setTableView] = useState<'basic' | 'compare'>('basic')

  if (detailsQuery.isLoading) {
    return <Skeleton active />
  }

  const canShowCompareTable = (detailsQuery.data?.quickBooksInvoice?.lineItems.length ?? 0) > 0
  const canShowLineItemsTable = typeof detailsQuery.data === 'object'
  const options: SegmentedOptions<SetStateAction<"basic" | "compare">> = [
    { label: 'Line Items', value: 'basic', icon: <FontAwesomeIcon icon={faList} /> },
  ]
  if  (invoiceSummary.invoicingSystem === 'quickBooks') {
    options.push({ label: 'QuickBooks Comparison', value: 'compare', icon: <FontAwesomeIcon icon={faTable} />, disabled: !canShowCompareTable })
  }
  
  return <VSpace>
    <Segmented
      style={{ marginLeft: '38px' }}
      value={tableView}
      onChange={setTableView}
      options={options}
    />
    {canShowLineItemsTable && <LineItemsTable
      detail={detailsQuery.data}
      invoiceSummary={invoiceSummary}
      view={tableView}
    />}
    {hasValue(detailsQuery.data) && <InvoiceControls
      invoiceSummary={invoiceSummary}
      detail={detailsQuery.data}
      preventExports={preventExports}
    />}
  </VSpace>
}

export default InvoiceDetails